import {Encoding} from './encoding';
export class Video {

  title: string;
  location: string;
  href: string;
  imageSrc: string;
  encodings: Encoding[] = [];
  fullFrameEncodings: Encoding[] = [];
  rtmpPath: string;
  httpPath: string;
  isCloudFront: boolean;

  static fromJSON(json: VideoJSON): Video {
    if (json) {
      const video = Object.assign(Object.create(Video.prototype), json, {
        encodings: JSON.parse(json.encodings),
        fullFrameEncodings: JSON.parse(json.fullFrameEncodings)
      });

      video.encodings = [];
      const encArray = JSON.parse(json.encodings);
      for (const enc of encArray) {
        video.encodings.push(Encoding.fromJSON(enc));
      }

      video.fullFrameEncodings = [];
      const ffEncArray = JSON.parse(json.fullFrameEncodings);
      for (const enc of ffEncArray) {
        video.fullFrameEncodings.push(Encoding.fromJSON(enc));
      }
      return video;
    }
    return null;
  }

  toJSON(): VideoJSON {
    return Object.assign({}, this, {
      encodings: JSON.stringify(this.encodings),
      fullFrameEncodings: JSON.stringify(this.fullFrameEncodings)
    });
  }

  constructor(public data: any) {
    let json: JSON = data;
    if (json) {
      this.location = json['location'];
      this.href = json['href'];
      this.imageSrc = json['imageSrc'];
      this.title = json['title'];

      if (json['sources']) {
        json = json['sources'];
        // the main tour videos have a "sources" node
        this.rtmpPath = json['rtmpPath'];

        // insure we're making HTTPS requests
        if (json['httpPath']) {
          this.httpPath = json['httpPath'].replace('http://', 'https://');
        }

        this.isCloudFront = json['isCloudFront'];

        if (json['encodings']) {
          for (const d of json['encodings']) {
            const encoding = new Encoding(d);
            this.encodings.push(encoding);
          }
        }

        if (json['fullFrameEncodings']) {
          for (const d of json['fullFrameEncodings']) {
            const encoding = new Encoding(d);
            this.fullFrameEncodings.push(encoding);
          }
        }

      } else if (json['encodings']) {
        // ads just have an "encodings" node
        for (const d of json['encodings']) {
          const encoding = new Encoding(d);
          this.encodings.push(encoding);
        }
      }
    }
  }
}

interface VideoJSON {
  title: string;
  location: string;
  href: string;
  imageSrc: string;
  encodings: string;
  fullFrameEncodings: string;
  rtmpPath: string;
  httpPath: string;
  isCloudFront: boolean;
}





// WEBPACK FOOTER //
// ./src/app/model/video.ts